import React, { Component } from "react";
import Loader from "react-loader-spinner";

const styles = {
  center: {
    display: "block",
    margin: "auto",
    width: "150px",
    marginTop: "150px",
    marginBotttom: "20px"
  }
};

class LoaderModule extends Component {
  render() {
    return (
      <div style={styles.center}>
        <Loader type="CradleLoader" color="#00BFFF" height="100" width="100" />
      </div>
    );
  }
}

export default LoaderModule;
